@if (notificationService.isVisible() && notificationService.notification(); as notification) {
  <div class="notification-container">
    <app-coinflip-win-notification
      [skins]="notification.skins"
      [totalValue]="notification.totalValue"
      (close)="onClose()"
      (acceptWinnings)="onAcceptWinnings()"
    />
  </div>
}
